<template>
  <div class="about">
    <Spacer/>
    <div class="about-container">This is an about page</div>
  </div>
</template>

<script>
import Spacer from '@/components/Spacer.vue'

export default {
  name: 'About',
  components: {
    Spacer
  }
}
</script>

<style scoped lang="scss">
.about-container {
  min-height: 100vh;
  min-height: --webkit-fill-available;
}
</style>
